"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticate = void 0;
const rest_1 = require("@/services/rest");
const store_1 = require("@/state/store");
const dataLayerLogin_1 = require("./dataLayerLogin");
const main_1 = require("@/main");
const contextPath = window.ocm.config.encodedContextPath;
const validateUrls = {
    login: `${contextPath}/rest/auth/keycloak/login/`,
    registration: `${contextPath}/rest/auth/keycloak/registration/`,
};
function authenticate(validationCredentials, action, csrfTokenAttempts = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        resetErrors();
        const validateUrl = validateUrls[action];
        const bodyData = new URLSearchParams(validationCredentials).toString();
        const fetchOptions = {
            method: "post",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body: bodyData,
        };
        //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        // make Request
        const responseData = yield (0, rest_1.fetchWithCSRFToken)(validateUrl, fetchOptions);
        const { httpStatus, globalErrorMessages, redirectUrl } = responseData;
        if (httpStatus === 200) {
            _handleOK(action, redirectUrl);
            return true;
        }
        else if (httpStatus === 412) {
            // _handle412 calls authenticate recursively and returns success as a Promise (true / false)
            return _handle412(action, validationCredentials, csrfTokenAttempts);
        }
        else if (httpStatus === 503) {
            handleNetworError();
        }
        else {
            const errorData = {
                errorMessages: globalErrorMessages || [(0, main_1.$t)("errorMessages.genericError")],
                httpStatus,
            };
            handleError(action, errorData);
        }
        return false;
    });
}
exports.authenticate = authenticate;
function _handleOK(action, redirectUrl) {
    if (redirectUrl) {
        location.assign(redirectUrl);
    }
    else {
        (0, dataLayerLogin_1.pushEvent)("backend_error", "missing_redirect_url");
        store_1.store.globalErrorMessages = [(0, main_1.$t)("errorMessages.genericError")];
    }
    if (action === "login")
        localStorage.setItem("loginTabActive", "true");
}
function _handle412(action, validationCredentials, csrfTokenAttempts) {
    if (csrfTokenAttempts++ < 3) {
        // call authenticate recursively and return success as a Promise (true / false)
        return authenticate(validationCredentials, action, csrfTokenAttempts);
    }
    store_1.store.httpErrorStatusCode = 412;
    store_1.store.globalErrorMessages = [(0, main_1.$t)("errorMessages.httpErrorStatusCode412")];
    // ERROR TRACKING
    handleErrorTracking(action, 412);
    return false;
}
function handleNetworError() {
    (0, dataLayerLogin_1.pushEvent)("backend_error", "invalid_authentication_response");
    store_1.store.globalErrorMessages = [(0, main_1.$t)("errorMessages.httpError")];
}
function handleError(action, errorData) {
    store_1.store.httpErrorStatusCode = errorData.httpStatus;
    store_1.store.globalErrorMessages = errorData.errorMessages;
    // EROOR TRACKING
    handleErrorTracking(action, errorData.httpStatus);
}
function handleErrorTracking(action, httpStatus) {
    const eventLabel = `${action}_error_status_${httpStatus.toString()}`;
    (0, dataLayerLogin_1.pushEvent)("backend_error", eventLabel);
}
function resetErrors() {
    store_1.store.httpErrorStatusCode = null;
    store_1.store.globalErrorMessages = [];
}
